import * as React from "react";
import { storageArea } from "../../utils/storageArea";

export interface AdminProps {
  showAdminTools: boolean;
  setShowAdminTools: (showAdminTools: boolean) => void;
}
export const AdminContext = React.createContext<AdminProps>(null);

export const AdminProvider = ({ children }: { children: React.ReactNode }) => {
  const [showAdminTools, _setShowAdminTools] = React.useState(
    storageArea.getItem("showAdminTools") === "true"
  );

  const setShowAdminTools = (showAdminTools: boolean) => {
    _setShowAdminTools(showAdminTools);
    if (showAdminTools) {
      storageArea.setItem("showAdminTools", "true");
    } else {
      storageArea.removeItem("showAdminTools");
    }
  };

  const value = { showAdminTools, setShowAdminTools };

  return (
    <AdminContext.Provider value={value}>{children}</AdminContext.Provider>
  );
};

export function useShowAdminTools() {
  return React.useContext(AdminContext).showAdminTools && !!window.isLocalIp;
}
